var map = {
	"./1.svg": 1094,
	"./2.svg": 1095,
	"./3.svg": 1096,
	"./arrow.svg": 452,
	"./default-bigwinning-icon.svg": 453,
	"./next-arrow.svg": 454,
	"./prev-arrow.svg": 455,
	"./result-url.svg": 456
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1093;